import {
    Box,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Skeleton,
    Typography,
} from '@mui/material';
import Icon from '@apigrowfinance/pbolt-icon';

import TransactionSkeleton from '@components/accountStatements/skeletons/TransactionSkeleton';

const StatementSkeleton = () => {
    return (
        <Grid item xs={12} sx={{ mt: 3, mb: 3 }}>
            <Typography
                variant="overline"
                data-testid="statement-month-typography">
                <Skeleton width={90} />
            </Typography>
            <Box
                sx={{
                    mt: 2,
                    bgcolor: 'background.paper',
                    width: '100%',
                }}>
                <List>
                    <ListItem
                        sx={{ pl: 2 }}
                        secondaryAction={
                            <ListItemText
                                primary={<Skeleton width={100} />}
                                secondary={<Skeleton width={140} />}
                            />
                        }>
                        <ListItemAvatar>
                            <Icon
                                data-testid="statement-loading-icon"
                                isLoading>
                                <div />
                            </Icon>
                        </ListItemAvatar>
                        <ListItemText
                            primary={<Skeleton width={140} />}
                            secondary={<Skeleton width={80} />}
                        />
                    </ListItem>
                    <TransactionSkeleton />
                </List>
            </Box>
        </Grid>
    );
};

export default StatementSkeleton;
